/** @jsx jsx */
import { useState } from 'react'
import { Button, Text, Spinner, jsx } from 'theme-ui'

const KeepShoppingButton = () => {

  return (
    <form action="/shop/">
      <Button type="submit" value="Keep Shopping"
        sx={{
          color: 'rgb(81, 39, 115)',
          backgroundColor: 'rgb(197, 179, 215)',
          '&:hover': {
            backgroundColor: 'rgb(197, 179, 215)',
            filter: 'brightness(0.9)',
          },
          borderRadius: '0.25rem',
          fontFamily: 'DIN Alternate Bold,Helvetica,Arial,Sans-Serif',
          marginTop: '1rem',
          padding: '12px 16px',
          transition: 'filter 0.15s ease-in-out 0s',
          width: '100%',
        }}
      >
        <Text variant="link">Keep Shopping</Text>
      </Button>
    </form>
  )
}

export default KeepShoppingButton
